import { MatDialog } from "@angular/material/dialog";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { SnackBarService } from "cw-utils";
import { AttendanceEditProvider } from "cw-backend";
import { ExclusionMotiveEditProvider } from "../../../../../../../../../shared/cw-backend/providers/operational-system/exclusion-motive/exclusion-motive-edit.provider";
import { ExclusionMotive } from "../../../../../../../../../shared/cw-backend/models/tables/operational/exclusion-motive";
import { PageOptions } from "../../../../../../../../../shared/cw-backend/util/page";
import { ExclusionMotiveListProvider } from "../../../../../../../../../shared/cw-backend/providers/operational-system/exclusion-motive/exclusion-motive-list.provider";
import { OrderItemPO } from "../../../../../../../../../shared/cw-backend/models/attendance/order-item";
import {
    FormGroup,
    FormBuilder,
    RequiredValidator,
    Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject, takeUntil, debounceTime, distinctUntilChanged } from "rxjs";
import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";

@Component({
    selector: "app-exclusion-motive",
    templateUrl: "./exclusion-motive.component.html",
    styleUrls: ["./exclusion-motive.component.scss"],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class ExclusionMotiveComponent implements OnInit {
    private _unsubscribeAll: Subject<any>;
    exclusionMotiveForm: FormGroup;
    exclusionPage: PageOptions;
    exclusionMotive: ExclusionMotive;
    confirmExclusionData: any;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    paymentModel = "";

    constructor(
        public _matDialogRef: MatDialogRef<ExclusionMotiveComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private exclusionMotiveListProvider: ExclusionMotiveListProvider,
        private exclusionMotiveEditProvider: ExclusionMotiveEditProvider,
        private attendanceEditProvider: AttendanceEditProvider,
        private _matDialog: MatDialog,
        private snackBarService: SnackBarService
    ) {
        this._unsubscribeAll = new Subject<any>();
        this.exclusionPage = new PageOptions();
    }

    ngOnInit() {
        if (this.data?.insurance) {
            console.log(
                "🚀 ~ ExclusionMotiveComponent ~ ngOnInit ~ this.data:",
                this.data
            );
            this.paymentModel = this.data.insurance.paymentModel;
        } else if (this.data?.paymentModel) {
            console.log(
                "🚀 ~ ExclusionMotiveComponent ~ ngOnInit ~ this.data:",
                this.data
            );
            this.paymentModel = this.data.paymentModel;
        } else {
            console.log(
                "🚀 ~ ExclusionMotiveComponent ~ ngOnInit ~ this.data:",
                this.data
            );
            this.paymentModel = this.data.order.insurance.paymentModel;
            console.log(
                "🚀 ~ ExclusionMotiveComponent ~ ngOnInit ~   this.paymentModel:",
                this.paymentModel
            );
        }
        this.exclusionMotiveForm = this.createForm();
        this.filterExclusionMotive();
        this.getMotiveExclusion();
    }

    getMotiveExclusion() {
        this.exclusionMotiveListProvider
            .getPageActiveTrue(this.exclusionPage)
            .then((response) => {
                this.exclusionMotive = response.body.content;
            });
    }

    filterExclusionMotive() {
        this.exclusionMotiveForm.controls["exclusionMotive"].valueChanges
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(500),
                distinctUntilChanged()
            )
            .subscribe((res) => {
                let filter = "";
                if (typeof res == "string") {
                    filter = res;
                }
                this.exclusionPage.argument = filter;
                this.getMotiveExclusion();
            });
    }

    displayFn(motive?: any): string | undefined {
        if (!motive) {
            return "";
        }
        return motive.name ? motive.name : motive;
    }

    createForm(): FormGroup {
        if (this.data.order) {
            return this._formBuilder.group({
                exclusionMotive: [null],
                orderId: [this.data.order.id],
                number: [this.data ? this.data.order.number : null],
                companyCostCenter: [
                    this.data.order
                        ? this.data.order.companyCostCenter.id
                        : null,
                ],
                companyName: [
                    this.data.order
                        ? this.data.order.companyCostCenter.company.name
                        : null,
                ],
                costCenterName: [
                    this.data.order
                        ? this.data.order.companyCostCenter.costCenter.name
                        : null,
                ],
                patient: [this.data.order ? this.data.order.patient.id : null],
                patientName: [
                    this.data.order.patient
                        ? this.data.order.patient.person.name
                        : null,
                ],
                insurance: [
                    this.data.order ? this.data.order.insurance.id : null,
                ],
                insuranceName: [
                    this.data.order ? this.data.order.insurance.name : null,
                ],
                performer: [this.data.orderitem.performer.id],
                performerName: [
                    this.data.orderitem.performer.professional.person.name,
                ],
                professional: [
                    this.data.orderitem.professional
                        ? this.data.orderitem.professional.id
                        : null,
                ],
                professionalName: [
                    this.data.orderitem.professional
                        ? this.data.orderitem.professional.person.name
                        : null,
                ],
                orderItem: [
                    this.data.orderitem ? this.data.orderitem.id : null,
                ],
                procedure: [
                    this.data.orderitem.procedure
                        ? this.data.orderitem.procedure.id
                        : null,
                ],
                procedureName: [
                    this.data.orderitem.procedure
                        ? this.data.orderitem.procedure.name
                        : null,
                ],
                procedureCode: [
                    this.data.orderitem.procedure
                        ? this.data.orderitem.code
                        : null,
                ],
                dateOrderItem: [
                    this.data.orderitem ? this.data.orderitem.date : null,
                ],
                hourOrderItem: [
                    this.data.orderitem ? this.data.orderitem.hour : null,
                ],
                valueOrderItem: [
                    this.data.orderitem ? this.data.orderitem.total : null,
                ],
                quantityOrderItem: [
                    this.data.orderitem ? this.data.orderitem.quantity : null,
                ],
                note: [null],
            });
        } else {
            return this._formBuilder.group({
                exclusionMotive: [null, Validators.required],
                orderId: [this.data.id],
                number: [null],
                companyCostCenter: [null],
                companyName: [null],
                costCenterName: [null],
                patient: [null],
                patientName: [null],
                insurance: [null],
                insuranceName: [null],
                performer: [null],
                performerName: [null],
                professional: [null],
                professionalName: [null],
                orderItem: [null],
                procedure: [null],
                procedureName: [null],
                procedureCode: [null],
                dateOrderItem: [null],
                hourOrderItem: [null],
                valueOrderItem: [null],
                quantityOrderItem: [null],
                note: [null],
            });
        }
    }

    checkFields() {
        let result: boolean = true;
        if (this.exclusionMotiveForm.invalid) {
            this.exclusionMotiveForm.controls[
                "exclusionMotive"
            ].markAsTouched();
            result = false;
        }
        return result;
    }

    confirm() {
        if (!this.checkFields()) {
            this.snackBarService.warnMessage(
                "Por favor preencha o campo em destaque!"
            );
            return;
        }

        let data = this.exclusionMotiveForm.getRawValue();

        if (!data.exclusionMotive.id) {
            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                }
            );
            this.confirmDialogRef.componentInstance.action =
                "Descrição não existe da tabela de motivos de exclusão, deseja criar?";

            this.confirmDialogRef.afterClosed().subscribe((result) => {
                if (result) {
                    let motive = new ExclusionMotive();
                    motive.name = data.exclusionMotive;
                    motive.active = true;
                    motive.id = null;
                    data.exclusionMotive = motive;

                    delete data.mainProcedure;
                    delete data.mainPerformer;
                    delete data.mainOrderItem;
                    delete data.agreement;

                    if (this.data.order) {
                        this.attendanceEditProvider
                            .insertExclusion(data)
                            .then((res) => {
                                this._matDialogRef.close(true);
                            })
                            .catch((err) => {});
                    } else {
                        this.attendanceEditProvider
                            .delete(data)
                            .then((res) => {
                                this._matDialogRef.close(true);
                            })
                            .catch((err) => {});
                    }
                } else {
                    this.exclusionMotiveForm.controls[
                        "exclusionMotive"
                    ].setValue(null);
                }
            });
        } else {
            delete data.mainProcedure;
            delete data.mainPerformer;
            delete data.mainOrderItem;
            delete data.agreement;

            if (this.data.order) {
                if (this.paymentModel != "P" && this.paymentModel != "O") {
                    this.attendanceEditProvider
                        .insertExclusion(data)
                        .then((res) => {
                            this._matDialogRef.close(true);
                        })
                        .catch((err) => {});
                } else {
                    this.attendanceEditProvider
                        .insertExclusionCash(data)
                        .then((res) => {
                            this._matDialogRef.close(true);
                        })
                        .catch((err) => {});
                }
            } else {
                if (this.paymentModel != "P" && this.paymentModel != "O") {
                    this.attendanceEditProvider
                        .delete(data)
                        .then((res) => {
                            this._matDialogRef.close(true);
                        })
                        .catch((err) => {});
                } else {
                    this.attendanceEditProvider
                        .deleteCash(data)
                        .then((res) => {
                            this._matDialogRef.close(true);
                        })
                        .catch((err) => {});
                }
            }
        }
    }

    dimiss() {
        this._matDialogRef.close();
    }
}
